// extracted by mini-css-extract-plugin
export default {"register-form":"RegisterForm_register-form__s0hqb","input-style":"RegisterForm_input-style__X3R5i","btn-style":"RegisterForm_btn-style__BvpOC"};